import './bootstrap';
import '../css/app.css';
import { createApp } from 'vue';
import App from './components/App.vue';
import router from './router';
import PrimeVue from 'primevue/config';
import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

const BrandPreset = definePreset(Aura, {
    semantic: {
        primary: {
            50: '#eefcfe',
            100: '#dcf8fc',
            200: '#bcf1f8',
            300: '#89e4f0',
            400: '#49d6e9',
            500: '#19bed4',
            600: '#119cae',
            700: '#0f7e8d',
            800: '#0f6773',
            900: '#0e565f',
            950: '#0b393f',
        },
        accent: {
            50: '#effef7',
            100: '#d7fded',
            200: '#b2f8db',
            300: '#7cefc0',
            400: '#3ddc97',
            500: '#1cc080',
            600: '#129a67',
            700: '#127a54',
            800: '#136045',
            900: '#124f3a',
            950: '#052c20',
        },
    },
    components: {
        button: {
            borderRadius: '0.75rem',
        },
        dialog: {
            borderRadius: '1rem',
        },
        inputtext: {
            borderRadius: '0.75rem',
        },
        select: {
            borderRadius: '0.75rem',
        },
    },
});

const app = createApp(App);

app.use(PrimeVue, {
    theme: {
        preset: BrandPreset,
        options: {
            ripple: true,
            // prefix: 'p',
            darkModeSelector: 'light',
        },
    },
});

app.use(router);

app.mount("#app");
